// extracted by mini-css-extract-plugin
export default {"adminLink":"HomePage_adminLink__CtIjG"};